import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
  },
}))

export default styles
